import { render } from "./RequestDashboard.vue?vue&type=template&id=23808234&scoped=true"
import script from "./RequestDashboard.vue?vue&type=script&lang=js"
export * from "./RequestDashboard.vue?vue&type=script&lang=js"

import "./RequestDashboard.vue?vue&type=style&index=0&id=23808234&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23808234"]])

export default __exports__